"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Section = _interopRequireDefault(require("../Section"));
var _Button = _interopRequireDefault(require("../../atoms/Button"));
var _Row = _interopRequireDefault(require("../../foundational/Layout/Row"));
var _Col = _interopRequireDefault(require("../../foundational/Layout/Col"));
var _useElementReference2 = _interopRequireDefault(require("../../hooks/useElementReference"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children", "observerElements", "CTAparams", "description"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".StickyFooter {\n  background-color: #ffffff;\n  padding: 0 !important;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  position: fixed;\n  transform: translateY(100%);\n  transition: ease-in-out 500ms;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5);\n  z-index: 3;\n}\n@media (max-width: 48rem) {\n  .StickyFooter {\n    transform: translateY(0%) !important;\n  }\n}\n.StickyFooter__peek {\n  transform: translateY(0%);\n}\n.StickyFooter__description {\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 48rem) {\n  .StickyFooter__description {\n    justify-content: center;\n  }\n}\n.StickyFooter__button {\n  display: flex;\n  justify-content: flex-end;\n  margin: 1rem 0;\n}\n.StickyFooter__button-center {\n  justify-content: center;\n}\n@media (max-width: 48rem) {\n  .StickyFooter__button {\n    justify-content: center;\n  }\n}";
  var fileName = "StickyFooter_StickyFooter";
  var element = document.querySelector("style[data-sass-component='StickyFooter_StickyFooter']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var StickyFooter = function StickyFooter(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$observerElements = _ref.observerElements,
    observerElements = _ref$observerElements === void 0 ? {} : _ref$observerElements,
    CTAparams = _ref.CTAparams,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var elementToWatch = observerElements.elementToWatch,
    rootMargin = observerElements.rootMargin,
    threshold = observerElements.threshold;
  var _useElementReference = (0, _useElementReference2["default"])(elementToWatch, rootMargin, threshold),
    isElementVisible = _useElementReference.isElementVisible;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Section["default"], _objectSpread(_objectSpread({
    className: "StickyFooter ".concat(className, " ").concat(isElementVisible ? '' : 'StickyFooter__peek')
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Row["default"], {
      children: [description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
        xs: 6,
        md: 8,
        className: "StickyFooter__description PT-1 PT-MD-0",
        children: description
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Col["default"], {
        xs: 6,
        md: description ? true : 12,
        className: "StickyFooter__button ".concat(description === '' ? 'StickyFooter__button-center' : ''),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
          size: "medium",
          href: CTAparams.path ? CTAparams.path : undefined,
          target: CTAparams.newTab ? '_blank' : '_self',
          onClick: CTAparams != null && CTAparams.callback ? CTAparams == null ? void 0 : CTAparams.callback : undefined,
          children: CTAparams.label
        })
      })]
    })
  }));
};
var _default = StickyFooter;
exports["default"] = _default;